import Axios from "../../../lib/Axios";

/**
 * Reported Users API Helper
 * 
 * API functions for reported users page
 */

/**
 * Get reported users list
 * @param {Object} filters - Filter parameters
 * @param {number} filters.limit - Pagination limit
 * @param {number} filters.page - Pagination page number
 * @returns {Promise} API response with user_reports array and pagination
 */
export const getReportedUsersList = async (filters = {}) => {
  const {
    limit = 50,
    page = 1,
  } = filters;

  // Build query parameters object
  const params = {
    limit: limit.toString(),
    page: page.toString(),
  };

  console.log("API Params:", params);

  // GET /admin/user-profile-reports
  const result = await Axios.get("admin/user-profile-reports", { params });
  const userReports = result?.data?.result?.user_reports || [];
  const pagination = result?.data?.result?.pagination || {};
  console.log(userReports)
  return {
    data: userReports,
    pagination: {
      currentPage: pagination.currentPage || page,
      limit: pagination.limit || limit,
      totalPages: pagination.totalPages || 1,
      totalRecords: pagination.totalRecords || 0,
    },
  };
};

/**
 * Get user reports
 * @param {Object} filters - Filter parameters
 * @param {string} filters.userId - User ID (required)
 * @param {number} filters.limit - Pagination limit
 * @param {number} filters.page - Pagination page number
 * @returns {Promise} API response with userReports array and pagination
 */
export const getUserReports = async (filters = {}) => {
  const {
    userId,
    limit = 50,
    page = 1,
  } = filters;

  if (!userId) {
    throw new Error("userId is required");
  }

  // Build query parameters object
  const params = {
    userId: userId,
    limit: limit.toString(),
    page: page.toString(),
  };

  console.log("User Reports API Params:", params);

  // GET /admin/user-reports
  const result = await Axios.get("admin/user-reports", { params });
  console.log("User Reports API Response:", result?.data);
  const userReports = result?.data?.result?.userReports || [];
  const pagination = result?.data?.result?.pagination || {};
  
  console.log("Processed User Reports:", userReports);
  console.log("Pagination:", pagination);
  
  return {
    reports: userReports,
    pagination: {
      currentPage: pagination.currentPage || page,
      limit: pagination.limit || limit,
      totalPages: pagination.totalPages || 1,
      totalRecords: pagination.totalCount || 0,
    },
  };
};

/**
 * Update user report
 * @param {Object} data - Update data
 * @param {string} data.reportUuid - Report UUID (required)
 * @param {string} data.state - State (optional)
 * @param {string} data.adminNote - Admin note (optional)
 * @returns {Promise} API response
 */
export const updateUserReport = async (data) => {
  const { reportUuid, state, adminNote } = data;
  
  if (!reportUuid) {
    throw new Error("reportUuid is required");
  }

  const body = {
    reportUuid,
  };

  if (state) {
    body.state = state;
  }
  if (adminNote !== undefined && adminNote !== null) {
    body.adminNote = adminNote;
  }

  console.log("Update User Report Body:", body);

  // POST /admin/user-reports/update
  const result = await Axios.post("admin/user-reports/update", body);
  
  return result?.data || {};
};

